(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["tabs"] && !Shopify.designMode) return;
  try {
    class PdpTabs extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
    }

    connectedCallback() {
      if (this.initialized) return;

      this.tablist = this.querySelector('[role="tablist"]');
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      if (!this.tablist || !this.tabs.length || !this.panels.length) return;

      this.addEventListener('click', this.handleClick);
      this.addEventListener('keydown', this.handleKeydown);
      this.initialized = true;
      this.activate(0);
    }

    disconnectedCallback() {
      if (!this.initialized) return;
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('keydown', this.handleKeydown);
      this.initialized = false;
    }

    handleClick(event) {
      const tab = event.target.closest('[role="tab"]');
      if (!tab) return;

      event.preventDefault();
      const index = this.tabs.indexOf(tab);
      if (index === -1) return;

      this.activate(index);
    }

    handleKeydown(event) {
      const tab = event.target.closest('[role="tab"]');
      if (!tab) return;

      const currentIndex = this.tabs.indexOf(tab);
      if (currentIndex === -1) return;

      const { key } = event;
      let nextIndex;

      if (key === 'ArrowLeft' || key === 'ArrowUp') {
        nextIndex = currentIndex - 1;
      } else if (key === 'ArrowRight' || key === 'ArrowDown') {
        nextIndex = currentIndex + 1;
      } else if (key === 'Home') {
        nextIndex = 0;
      } else if (key === 'End') {
        nextIndex = this.tabs.length - 1;
      } else {
        return;
      }

      event.preventDefault();
      const index = (nextIndex + this.tabs.length) % this.tabs.length;
      this.activate(index, true);
    }

    activate(index, focus = false) {
      this.tabs.forEach((tab, tabIndex) => {
        const isActive = tabIndex === index;
        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;
      });

      this.panels.forEach((panel, panelIndex) => {
        const isActive = panelIndex === index;
        panel.hidden = !isActive;
        panel.toggleAttribute('inert', !isActive);
        panel.tabIndex = isActive ? 0 : -1;
      });

      if (focus) {
        this.tabs[index]?.focus();
      }
    }
  }

  if (!customElements.get('pdp-tabs')) {
    customElements.define('pdp-tabs', PdpTabs);
  }
  } catch(e) { console.error(e); }
})();

})();
